module.exports = __webpack_public_path__ + "img/128x128_star_black_hole_binary.ba1eb895.svg";